module.exports = __webpack_public_path__ + "img/shop2.bbeda9ff.png";